import { ReportExportStringsMode } from 'app/modules/reports/features/extracted-strings/types'

export type ScanProfileOptions = {
  early_termination: boolean
  osint: boolean
  extended_osint: boolean
  extracted_files_osint: boolean
  visualization: boolean
  files_download: boolean
  input_file_yara: boolean
  extracted_files_yara: boolean
  certificates: boolean
  url_analysis: boolean
  ocr_qr: boolean
  extract_strings: boolean
  phishing_detection: boolean
}

export type DeprecatedScanOptions = {
  rapid_mode: boolean
  resolve_domains: boolean
  whois: boolean
  ips_meta: boolean
  images_ocr: boolean
}

export type ScanProfile = {
  id?: string
  name: string
  is_editable: boolean
  is_default: boolean
  description?: string
  options: ScanProfileOptions
}

export type ReportExportProfile = {
  id?: string
  name: string
  is_editable: boolean
  is_default: boolean
  description?: string
  options: ReportExportProfileOptions
}

export type ReportExportProfileOptions = {
  all_pages: boolean
  pages: string[]
  strings_limit: number
  strings_mode: ReportExportStringsMode
}

export type CasualPassword = {
  id?: string
  content: string
  description: string | null
}

export const deprecatedScanOptions = ['rapid_mode', 'resolve_domains', 'whois', 'ips_meta', 'images_ocr']
